/**
 * Las tres barras inclinadas del logo de SMG, como motivo del sistema. Es el mismo trazo del
 * favicon (assets/favicon.svg del sitio corporativo): tres rectángulos con skew de -18°.
 *
 * Se usa como acento, no como relleno: junto a un título, al pie de una tarjeta, en el login.
 * La altura la da `alto` (px); el ancho sale de la proporción del logo.
 */
export function Barras({ alto = 14, color = "currentColor" }: { alto?: number; color?: string }) {
  // Geometría del favicon: barras de 8×32 separadas 14, skewX(-18°) → ancho total ≈ 52 + 32·tan(18°)
  const ancho = Math.round((alto * 62.4) / 32);
  return (
    <svg width={ancho} height={alto} viewBox="0 0 62.4 32" role="presentation" aria-hidden="true">
      <g fill={color} transform="translate(10.4,0) skewX(-18)">
        <rect x="0" y="0" width="8" height="32" rx="1" />
        <rect x="14" y="0" width="8" height="32" rx="1" />
        <rect x="28" y="0" width="8" height="32" rx="1" />
      </g>
    </svg>
  );
}

/** Marca completa: logo en blanco (para fondos marino) o en color (para fondos claros). */
export function Logo({ variante, alto = 36 }: { variante: "blanco" | "color"; alto?: number }) {
  return (
    <img
      src={variante === "blanco" ? "/marca/logo-blanco.png" : "/marca/logo.png"}
      alt="SMG Comercial · Creamos sabores y soluciones"
      height={alto}
      style={{ height: alto, width: "auto" }}
      draggable={false}
    />
  );
}
